
import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client, DamageMechanismDto } from '@fdm/api-client';
import { MaterialModule } from '@fdm/material';
import { map, shareReplay } from 'rxjs';

@Component({
  selector: 'app-report-form',
  imports:[CommonModule, MaterialModule, ReactiveFormsModule],
  templateUrl: './add-damage-mechanism-dialog.component.html',
  styleUrl: './add-damage-mechanism-dialog.component.scss'
})
export class AddDamageMechanismDialogComponent {

  apiClient = inject(Client);
  damageMechanismsFormControl = new FormControl<DamageMechanismDto[]>([] as DamageMechanismDto[]);
  allDamageMechanisms = [] as DamageMechanismDto[];
  damageMechanisms$ = this.apiClient.damageMechanismAll().pipe(
    map(items => items.filter(item => item.status === 'Active')),
    shareReplay(1)
  );
  compareById = (o1: DamageMechanismDto, o2: DamageMechanismDto) => o1 && o2 && o1.id === o2.id;

  constructor(
    private dialogRef: MatDialogRef<AddDamageMechanismDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      const selectedItems = data.selectedItems as DamageMechanismDto[]
        this.damageMechanismsFormControl.setValue(selectedItems);
    }

  removeItem(damageMechanism: DamageMechanismDto): void {
    const current = this.damageMechanismsFormControl.value ?? [];
    this.damageMechanismsFormControl.setValue(current.filter(f => f.id !== damageMechanism.id));
  }

  onAdd(){
    const current = this.damageMechanismsFormControl.value ?? [];
    this.dialogRef.close(current);
  }

  onClose(){
    this.dialogRef.close();
  }
}
